var _defs, _path, _polygon, _g, _path2, _path3, _path4, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartsArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24pt",
    height: "24pt",
    viewBox: "0 0 360 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0, .st1 {\r\n        fill: none;\r\n      }\r\n\r\n      .st2, .st3, .st4 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st2, .st4 {\r\n        stroke: var(--ha-icon-grey);\r\n      }\r\n\r\n      .st5 {\r\n        fill: var(--ha-icon-red);\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .st1 {\r\n        stroke: #000;\r\n      }\r\n\r\n      .st1, .st4 {\r\n        stroke-width: .25px;\r\n      }\r\n\r\n      .st6 {\r\n        fill: var(--ha-icon-grey);\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M209.98,106.07c0,57.77-46.83,104.59-104.59,104.59S.79,163.84.79,106.07,47.62,1.48,105.39,1.48s104.59,46.83,104.59,104.59Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "34.05 33.1 92.66 73.74 105.37 3.55 118.07 73.74 176.68 33.1 136.04 91.71 206.22 104.41 136.04 117.12 176.68 175.73 118.07 135.09 105.37 205.27 92.66 135.09 34.05 175.74 74.7 117.12 4.51 104.41 74.7 91.71 34.05 33.1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "173.04 131.67 183.89 131.94 205.95 120.4 184.65 111.24 138.79 118.04 168.07 154.9 188.54 163.48 181.83 138.79 173.04 131.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "172.91 110.44 133.93 115.95 158.1 146.37 108.93 105.52 172.91 110.44"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "38.92 76.92 28.07 76.65 6.01 88.19 27.31 97.34 73.17 90.55 43.89 53.69 23.42 45.1 30.13 69.79 38.92 76.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "39.05 98.14 78.03 92.64 53.86 62.21 103.03 103.06 39.05 98.14"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "78.62 171.36 78.35 182.22 89.89 204.27 99.05 182.97 92.25 137.11 55.39 166.39 46.8 186.86 71.49 180.15 78.62 171.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "99.85 171.24 94.34 132.25 63.92 156.41 104.77 107.25 99.85 171.24"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "133.37 37.25 133.64 26.38 122.1 4.33 112.95 25.63 119.74 71.49 156.6 42.21 165.19 21.74 140.5 28.45 133.37 37.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "112.14 37.37 117.65 76.35 148.08 52.18 107.22 101.35 112.14 37.37"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "134.04 171.07 141.53 178.94 165.29 186.37 156.7 164.84 119.47 137.22 114.1 183.98 122.51 204.53 135.22 182.33 134.04 171.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "148.97 155.97 117.51 132.3 113.08 170.9 107.2 107.25 148.97 155.97"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "77.93 37.52 70.44 29.65 46.68 22.21 55.27 43.75 92.5 71.38 97.87 24.61 89.46 4.06 76.75 26.26 77.93 37.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "63 52.62 94.46 76.29 98.89 37.69 104.77 101.34 63 52.62"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "39.22 132.37 31.35 139.86 23.91 163.62 45.45 155.02 73.07 117.79 26.31 112.43 5.76 120.83 27.96 133.55 39.22 132.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "54.31 147.29 77.98 115.84 39.39 111.41 103.04 105.53 54.31 147.29"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "172.76 76.25 180.64 68.76 188.07 45.01 166.53 53.6 138.91 90.83 185.67 96.19 206.23 87.79 184.02 75.07 172.76 76.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "157.67 61.33 134 92.78 172.6 97.21 108.95 103.09 157.67 61.33"
  })))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.15,166.38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.32,30.55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M359.14,253.37c0,58-47.02,105.01-105.01,105.01s-105.01-47.02-105.01-105.01,47.02-105.01,105.01-105.01,105.01,47.02,105.01,105.01Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "280.28 151.57 284.46 152.8 289.53 154.54 274.27 172.75 280.28 151.57"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "228.73 151.57 224.54 152.8 219.48 154.54 234.74 172.75 228.73 151.57"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "279.33 354.94 283.52 353.71 288.59 351.97 273.33 333.76 279.33 354.94"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "227.79 354.94 223.6 353.71 218.54 351.97 233.8 333.76 227.79 354.94"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "355.81 279.01 354.58 283.2 352.84 288.26 334.62 273 355.81 279.01"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "355.81 227.47 354.58 223.28 352.84 218.21 334.62 233.47 355.81 227.47"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "152.44 278.07 153.67 282.26 155.41 287.32 173.62 272.06 152.44 278.07"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "152.44 226.53 153.67 222.34 155.41 217.27 173.62 232.53 152.44 226.53"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "234.21 203.61 254.18 235.41 274.85 204.06 266.48 240.67 303.26 233.11 271.46 253.08 302.81 273.74 266.2 265.38 273.75 302.16 253.79 270.36 233.12 301.7 241.49 265.1 204.71 272.66 236.51 252.69 205.16 232.02 241.77 240.39 234.21 203.61"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "254.23 148.36 263.15 184.48 257.1 193.16 263.15 231.58 254.16 236.12 245.1 231.58 251.39 193.22 245.1 184.48 254.23 148.36"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "254.07 358.52 262.99 322.4 256.94 313.72 262.99 275.3 253.99 270.76 244.94 275.3 251.22 313.66 244.94 322.4 254.07 358.52"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "359.21 253.4 323.08 262.32 314.4 256.27 275.98 262.32 271.45 253.32 275.98 244.27 314.35 250.56 323.08 244.27 359.21 253.4"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328.22 179.35 308.98 211.19 298.56 213.06 275.67 244.5 266.11 241.35 262.91 231.74 294.48 209.06 296.21 198.43 328.22 179.35"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "328.16 327.85 296.32 308.62 294.45 298.2 263.01 275.31 266.16 265.74 275.77 262.54 298.46 294.12 309.08 295.85 328.16 327.85"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "148.69 253.64 184.81 244.72 193.5 250.78 231.92 244.72 236.45 253.72 231.92 262.78 193.55 256.49 184.81 262.78 148.69 253.64"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "179.68 327.69 198.92 295.85 209.34 293.99 232.23 262.54 241.79 265.69 244.99 275.3 213.41 297.99 211.68 308.61 179.68 327.69"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "179.73 179.19 211.58 198.43 213.44 208.85 244.89 231.74 241.73 241.3 232.12 244.5 209.44 212.92 198.82 211.19 179.73 179.19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartsArrows);
export default __webpack_public_path__ + "static/media/hearts-arrows.27954ba885ecd1b44a39b12bc5b28fa1.svg";
export { ForwardRef as ReactComponent };